import { Box } from '@pinchenterprisesnpm/friday-ui'
import { UNMAPPED_COLORS } from '@src/helpers/constants/colors'
import styled from 'styled-components'

export const ProTipSegmentContainer = styled(Box)`
  background-color: ${UNMAPPED_COLORS.lightBlueGradient};
  border-radius: 4px;
  border: 1px solid ${({ theme: { palette } }) => palette.primary};
  padding: ${({ theme: { mp } }) => mp.md};
`
